import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Errore innocuo di ResizeObserver (Radix): evita l'overlay di errore in sviluppo
window.addEventListener('error', (e) => {
  if (e.message && e.message.startsWith('ResizeObserver loop')) e.stopImmediatePropagation();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);